import { MotifAccordion, MotifAccordionContent, MotifAccordionTrigger, MotifButton, MotifIcon } from '@ey-xd/motif-react'
import React from 'react'
import iconSvg from "../../assets/icons/icon.svg.json";
import WorkspaceDocsTable from './WorkspaceDocsTable';
import { useDispatch, useSelector } from 'react-redux';

const WorkspaceDocAccordion = (props: any) => {
    const { documentType, versions } = props
    const dispatch = useDispatch();
    
    const { access } = useSelector((state: any) => state.user);
    const openUploadDialog = (data: any) => {
        dispatch({
            type: "OPEN_WORKSPACE_DIALOG",
            payload: {
                dialogType: "UPLOAD_DOCUMENT_VERSION",
                ...data
            }
        })
    }
    return (
        <>
            <MotifAccordion
                onClose={function Ga() { }}
                onOpen={function Ga() { }}
                style={{
                    flex: '1'
                }}
            >
                <MotifAccordionTrigger>
                    {documentType}
                </MotifAccordionTrigger>
                <MotifAccordionContent>
                    <div className="flex flex-col gap-2">
                        <div className="flex justify-between items-center">
                            <h6 className="font-bold">Version</h6>
                            {access?.write === true && (
                                <MotifButton
                                    onClick={() => {
                                        openUploadDialog(props)
                                    }}
                                    size="small"
                                    type="submit"
                                    variant="primary"
                                    className="!p-2 !h-7"
                                >
                                    <MotifIcon src={iconSvg["upload-icon"]} className="!w-4" title='upload' />
                                </MotifButton>
                            )}
                        </div>
                        <WorkspaceDocsTable tableData={versions} />
                    </div>
                </MotifAccordionContent>
            </MotifAccordion>
        </>
    )
}

export default WorkspaceDocAccordion